import React from 'react';
import BulkUploadTabs from './BulkUploadTabs';
import SearchBar from './SearchBar';
import useAuth from '../hooks/useAuth.js'; 

function BulkUpload() {
    const { auth } = useAuth(); 
    return (
        <>
            <h2 className="font-poppins font-medium text-[20px] leading-[100%] tracking-[0%] text-gray-main pb-3 border-b border-gray-d-200 dark:text-white dark:border-white mb-[20px]">Welcome {(auth.profile_name !== 'null') ? auth.profile_name : auth.profile_username} - Bulk Upload Page</h2>
            <div className='bulkupload-page max-w-[750px] mx-auto mt-11'>
                <BulkUploadTabs />            
            </div>
        </>
        
    );
}
export default BulkUpload;
